import { Pagination } from "antd";

export const LIST_PAGE_SIZE_OPTIONS = ["10", "20", "50", "100"];
export const LIST_DEFAULT_PAGE_SIZE = 10;

/** Cắt mảng theo trang — dùng cho danh sách phân trang phía client. */
export function sliceByPage(list, page, pageSize) {
  const start = (page - 1) * pageSize;
  return list.slice(start, start + pageSize);
}

const LIST_KEYS = ["matches", "data", "items", "rows", "schedules", "rankings"];

/** Lấy mảng bản ghi từ payload BE (nhiều shape). */
export function parseListFromPayload(payload) {
  if (payload == null) return [];
  for (const key of LIST_KEYS) {
    if (Array.isArray(payload?.[key])) return payload[key];
  }
  return Array.isArray(payload) ? payload : [];
}

/** Tổng bản ghi phân trang server — fallback độ dài trang hiện tại. */
export function parseTotalFromPayload(payload, listLength = 0) {
  const raw =
    payload?.total ??
    payload?.totalCount ??
    payload?.totalRecords ??
    payload?.count;
  const n = Number(raw);
  return Number.isFinite(n) && n >= 0 ? n : listLength;
}

export const LIST_MAX_PAGE_SIZE = 100;

/** Query `page` + `pageSize` (giới hạn max 100) cho API phân trang server. */
export function buildPageQuery(page, pageSize) {
  const p = Math.max(1, Number(page) || 1);
  const size = Math.min(
    Number(pageSize) || LIST_DEFAULT_PAGE_SIZE,
    LIST_MAX_PAGE_SIZE
  );
  return { page: p, pageSize: size, query: `page=${p}&pageSize=${size}` };
}

/**
 * @param {number} page
 * @param {number} pageSize
 * @param {(page: number, pageSize: number) => void} setPage
 * @param {(size: number) => void} setPageSize
 */
export function createPageChangeHandler(page, pageSize, setPage, setPageSize) {
  return (nextPage, nextSize) => {
    if (typeof nextSize === "number" && nextSize !== pageSize) {
      setPageSize(nextSize);
      setPage(1);
      return;
    }
    setPage(nextPage);
  };
}

/**
 * Phân trang chuẩn: «Tổng cộng N …» | số trang | «10 / page».
 * @param {object} props
 * @param {number} props.current
 * @param {number} props.total
 * @param {number} [props.pageSize]
 * @param {(page: number, pageSize: number) => void} props.onChange
 * @param {string} [props.unit] — đơn vị sau số (vd. tài khoản, dữ liệu, trận đấu)
 */
export default function ListPagination({
  current,
  total,
  pageSize = LIST_DEFAULT_PAGE_SIZE,
  onChange,
  unit = "bản ghi",
  pageSizeOptions = LIST_PAGE_SIZE_OPTIONS,
  style,
}) {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        marginTop: 15,
        justifyContent: "flex-end",
        ...style,
      }}
    >
      <Pagination
        current={current}
        total={total}
        pageSize={pageSize}
        onChange={onChange}
        pageSizeOptions={pageSizeOptions}
        showSizeChanger
        showQuickJumper={false}
        showTotal={(t) => `Tổng cộng ${t} ${unit}`}
      />
    </div>
  );
}
